import { ErrorState, ID } from 'types';

/**
 * Checks if there are any errors in the provided lotsErrors object.
 * The lotsErrors object is a mapping of lot IDs to their respective error states.
 *
 * @param lotsErrors - An object where each key is a lot ID and the value is an ErrorState object.
 * @returns True if there are errors, false otherwise.
 */
export const hasErrors = (lotsErrors: Record<ID, ErrorState<ID>>): boolean => {
  return Object.values(lotsErrors ?? {}).some(errorState => (
    Object.values(errorState ?? {}).some(columns => Boolean(columns?.length))
  ));
};
